import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumberSpacing',
    standalone: true,
})
export class PhoneNumberSpacingPipe implements PipeTransform {
    /**
     * @type {string}
     */
    private readonly SEPARATOR = '\u00A0';

    /**
     * Transforms 0611223344 to 06 11 22 33 44 with non-breaking spaces
     * @param {string} value Text to be filtered
     * @returns {string} Filtered text
     */
    public transform(value: string): string {
        if (!value) {
            return '';
        }
        const fiveCouple =
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/) ||
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d{2})(\d{2})(\d)/);
        const fourCouple =
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d{2})(\d{2})/) ||
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d{2})(\d)/);
        const threeCouple =
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d{2})/) ||
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})(\d)/);
        const twoCouple =
            value.replace(/\D/g, '').match(/(\d{2})(\d{2})/) || value.replace(/\D/g, '').match(/(\d{2})(\d)/);
        const oneCouple = value.replace(/\D/g, '').match(/(\d{2})/) || value.replace(/\D/g, '').match(/(\d)/);
        let valueToReturn;
        if (fiveCouple) {
            valueToReturn = `${fiveCouple[1]}${this.SEPARATOR}${fiveCouple[2]}${this.SEPARATOR}${fiveCouple[3]}${this.SEPARATOR}${fiveCouple[4]}${this.SEPARATOR}${fiveCouple[5]}`;
        } else if (fourCouple) {
            valueToReturn = `${fourCouple[1]}${this.SEPARATOR}${fourCouple[2]}${this.SEPARATOR}${fourCouple[3]}${this.SEPARATOR}${fourCouple[4]}`;
        } else if (threeCouple) {
            valueToReturn = `${threeCouple[1]}${this.SEPARATOR}${threeCouple[2]}${this.SEPARATOR}${threeCouple[3]}`;
        } else if (twoCouple) {
            valueToReturn = `${twoCouple[1]}${this.SEPARATOR}${twoCouple[2]}`;
        } else if (oneCouple) {
            valueToReturn = oneCouple[1];
        } else {
            valueToReturn = value;
        }
        return valueToReturn;
    }
}
